/**
 * @generated SignedSource<<93c3e416d2ceff99bfc44943e6f86f83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type SkillsProgressReportFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillIds: ReadonlyArray<string>;
};
export type ProgressCsvResultsReportQuery$variables = {
  filter: SkillsProgressReportFilterInput;
  skip?: boolean | null | undefined;
};
export type ProgressCsvResultsReportQuery$data = {
  readonly skillsProgressReport?: ReadonlyArray<{
    readonly skill: {
      readonly id: string;
    };
    readonly skillsResults: ReadonlyArray<{
      readonly key: SkillResult;
      readonly value: number;
    }>;
  }>;
};
export type ProgressCsvResultsReportQuery = {
  response: ProgressCsvResultsReportQuery$data;
  variables: ProgressCsvResultsReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "SkillReportProgress",
        "kind": "LinkedField",
        "name": "skillsProgressReport",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfSkillResultAndInt32",
            "kind": "LinkedField",
            "name": "skillsResults",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProgressCsvResultsReportQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProgressCsvResultsReportQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "155ff0bb6e771f8d5c45c89cd99faff9",
    "id": null,
    "metadata": {},
    "name": "ProgressCsvResultsReportQuery",
    "operationKind": "query",
    "text": "query ProgressCsvResultsReportQuery(\n  $filter: SkillsProgressReportFilterInput!\n  $skip: Boolean = false\n) {\n  skillsProgressReport(filter: $filter) @skip(if: $skip) {\n    skill {\n      id\n    }\n    skillsResults {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9fd268a52c1423603096038ec49d97f0";

export default node;
